export default "__VITE_ASSET__BwRsvTa7__"